import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/en/regions/nuernberg")({
  head: () => {
    const h = pageHead("region:nuernberg", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="nuernberg" locale="en" />,
});
